import {FC, memo} from 'react';
import cx from 'classnames';

import PythonExpressionParser from '../PythonExpressionParser';
import PythonExpressionJSXFormatter from '../PythonExpressionJSXFormatter';

import './FormattedPythonExpression.less';

type FormattedPythonExpressionProps = {
  value: string,
  multiLine?: boolean,
};

const FormattedPythonExpression: FC<FormattedPythonExpressionProps> = memo(({value, multiLine}) => {
  let formattedValue;
  const {cst, lexErrors, parseErrors} = PythonExpressionParser.parse(value);
  if (!lexErrors.length && !parseErrors.length) {
    formattedValue = PythonExpressionJSXFormatter.run(cst, {multiLine});
  }
  return <span className={cx('python-expression', {multiline: multiLine})}>{formattedValue ?? value}</span>;
});

export default FormattedPythonExpression;
